export const ActionType = {
  Ban: 1,
  BanRandom: 2,
  Pick: 3,
  PickRandom: 4
};

export const ActionWords = {
  [ActionType.Ban]: {
    base: "Бан",
    action: "Банит",
    completeAction: "Забанить"
  },
  [ActionType.Pick]: {
    base: "Пик",
    action: "Пикает",
    completeAction: "Пикнуть"
  }
};

export const ActionWordsSecondary = {
  [ActionType.Ban]: "Банит",
  [ActionType.Pick]: "Пик"
};

export const PicksStatus = {
  Upcoming: "waiting",
  Inprogress: "in progress",
  Finished: "finished"
};
